import TagManager from 'react-gtm-module';

import environment from '@/modules/cart/environments/environment';

const { GTM_ID } = environment;

export const initializeTagManager = (): void => {
  try {
    TagManager.initialize({
      gtmId: GTM_ID as string
    });
  } catch (err) {
    console.log('gtm error', err);
  }
};

/**
 * Function to send a dataLayer event
 * @param dataLayer - The event data to trigger
 */
export const sendGtmEvent = (dataLayer: object | undefined): void => {
  TagManager.dataLayer({
    dataLayer
  });
};
